export type SolutionKey = 'property' | 'people'

/**
 * The two product categories, in display order. Single source of truth for the
 * header menu, the landing apps section and the solution hero: they all read
 * the route, the mascot and the watermark from here, so a mascot swap is a
 * one-line change instead of three.
 */
export const SOLUTION_KEYS: readonly SolutionKey[] = ['property', 'people']

export const SOLUTIONS: Record<
  SolutionKey,
  { to: string; mascotFull: string; watermark: string; illustration: string }
> = {
  // ponytail: only two mascot renders exist, both evacuation-flavoured, so
  // property gets the Evac lanyard by elimination. Swap when a compliance
  // mascot lands.
  property: {
    to: '/$locale/solutions/property-security',
    mascotFull: '/mascot/mascot-2-full.webp',
    watermark: '/apps/property-security-big-icon.webp',
    illustration: '/backgrounds/property-security-illustration.webp',
  },
  people: {
    to: '/$locale/solutions/people-security',
    mascotFull: '/mascot/mascot-1-full.webp',
    watermark: '/apps/people-security-big-icon.webp',
    illustration: '/backgrounds/people-security-illustration.webp',
  },
}
